/* eslint-disable no-console */
/* eslint-disable no-dupe-keys */
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Formik,
  Field,
  Form,
  validateYupSchema,
  yupToFormErrors,
  setNestedObjectValues,
} from "formik";
import { useDispatch, useSelector } from "react-redux";
import _omit from "lodash/omit";
import _pickBy from "lodash/pickBy";
import _isEqual from "lodash/isEqual";
import _isEmpty from "lodash/isEmpty";
import _merge from "lodash/merge";
import NamesForm from "../../NamesComponents/index";
import IdentificationDetailsForm from "../../PersonalDetailsComponents";
import FileUploadForm from "../../FileUploadForm";
import getInitialValues from "./getInitialValues";
import getValidationSchema from "./getValidationSchema";
import { getDocumentData } from "../../FileUploadForm/documentData";
import {
  addCompanyOfficialAsync,
  updateCompanyOfficialAsync,
} from "state/slices/tables/companyOfficialsSlice";
import { closeModal } from "state/slices/modals";
import { resetSharesTable } from "state/slices/tables/sharesAllocationTable";
import { handleFilesUpload } from "utils/filesUtils";
import Verify from "components/lib/Shared/Verify";
import {
  clearEmpties,
  getFullName,
  getMaskedEmail,
  isProfessional,
} from "utils";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { useParams } from "react-router-dom";
import SectionDescription from "components/lib/Shared/SectionDescription";
import InviteNewUser from "components/lib/Shared/Verify/InviteNewUser";
import InviteExistingUser from "components/lib/Shared/Verify/InviteExistingUser";
import ResidentialDetails from "./ResidentialDetails";
import ErrorBanner from "components/lib/Shared/ErrorBanner";
import { Constants } from "config/constants";
import ChangedDocuments from "components/lib/Shared/ChangedDocuments";
import ChangesContext from "context/ChangesContext";
import AppointmentContext from "context/AppointmentContext";
import ManageAppointmentDate from "./ManageAppointmenDate";
import { handleCompanyMaintenanceFormData } from "utils/transactionRequestHandler";
import {
  convertTemplateToPdfAsync,
  uploadTemplateFileAsync,
} from "state/slices/templateFile";
import { getAllInitiateTransactionChangeAsync } from "state/slices/initiateTransactionChange";
import CompanyDashboardContext from "context/CompanyDashboardContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import TransactionEditContext from "context/TransactionEditContext";
import AlternateDirectorsForm from "./AlternateDirectorsForm";
import UpdateCompanyDetailsContext from "context/UpdateCompanyDetails";
import { getChangedDocumentsModuleData } from "config/documentData";
import * as Yup from "yup";

const formFields = [
  "type",
  "inviteStatus",
  "names",
  "identificationDetails",
  "isNonResident",
  "postalAddress",
  "electronicAddress",
  "residentialAddressDetails",
  "fileUploads",
  "inviteStatus",
];

const CompanyOfficialsAuthorizedDirectorForm = (props) => {
  const [validationSchema, setValidationSchema] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [showIdentificationSection, setShowIdentificationSection] =
    useState(true);
  const [verificationValue, setVerifyingValue] = useState("");
  const [isIdAssociated, setIsIdAssociated] = useState(null);
  const { isInChangesModule, displayRecentChangesAndApprovals } =
    useContext(ChangesContext);
  const { isInTransactionEditContext } = useContext(TransactionEditContext);
  const {
    isInUpdateCompanyDetailsContext,
    createdTransactionsIds,
    setCreatedTransactionsIds,
    transactionToEdit,
  } = useContext(UpdateCompanyDetailsContext);
  let showAppointmentDate = false;
  if (isInChangesModule || isInUpdateCompanyDetailsContext) {
    showAppointmentDate = true;
  }
  const {
    setSelectedOfficial,
    setNewlyCreatedTransaction,
    newlyCreatedTransaction,
  } = useContext(CompanyDashboardContext);
  const [disableForm, setDisableForm] = useState(false);
  const [inviteNewUserWorkflow, setInviteNewUserWorkflow] = useState(false);
  const [isAccessAllowed, setIsAccessAllowed] = useState(false);
  const [isAccessRevoked, setIsAccessRevoked] = useState(false);
  const [inviteExistingUser, setInviteExistingUser] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [openKey, setOpenKey] = useState(null);
  const formStepErrors = useRef(null);
  const currentUser = useSelector((state) => state.userSlice);
  const [isAddingOfficial, setIsAddingOfficial] = useState(false);
  const trxStorageKey = "trxRef";

  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const { company } = useSelector((state) => state.companySlice);
  const { transformedComments } = useSelector((state) => state.commentsSlice);
  const { initiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );
  const { batchNo } = useSelector((state) => state.batchNumberSlice);
  const {
    mode,
    currentOfficial,
    toggleShowOfficialsForm,
    idType,
    designation,
    isDirector = "No",
    selectedTab,
    isFirstStep,
    isLastStep,
    goToPrevStep,
    goToNextStep,
    isViewOnly,
    setTabsClickable,
    isSameTransaction,
    setSelectedTabIndex,
    directorsList,
    changingShareholderDesignation = false,
  } = props;

  const documentData = getDocumentData(idType);
  const documentNames = documentData.map((doc) => doc.name);
  /** Set directors list */
  if (directorsList && directorsList?.length > 0) {
    currentOfficial.directorsList = directorsList;
  }

  const closeVerifyProcess = () => {
    toggleShowOfficialsForm(false);
    dispatch(resetSharesTable());
  };

  useEffect(() => {
    setVerifyingValue("");
    setIsIdAssociated(null);
    setInviteNewUserWorkflow(false);
    setIsAccessAllowed(false);
    setIsAccessRevoked(false);
    if (!mode.editing || isViewOnly || changingShareholderDesignation)
      setDisableForm(true);
  }, [idType]);

  useEffect(() => {
    setInitialValues(
      _merge(
        getInitialValues({
          idType,
          isNonResident: currentOfficial.isNonResident,
          documentData,
        }),
        currentOfficial
      )
    );
  }, [selectedTab, idType, currentOfficial, documentData]);

  const createUploadFilePayload = (companyId, payload, officialId) => {
    let fileName;
    let modeType;
    let subModeType;

    if (payload.fileUploads?.consentFormForAuthorizedPerson) {
      fileName = payload.fileUploads.consentFormForAuthorizedPerson;
      modeType = "pre-signed-documents";
      subModeType = "self-resolution-type";
    } else if (
      payload.consentResolutionType?.consentResolutionType ===
      "ownResolutionType"
    ) {
      fileName = payload.fileUploads.consentResolutionType;
      modeType = "not-signed-documents";
      subModeType = "self-resolution-type";
    } else if (
      payload.consentResolutionType?.consentResolutionType ===
      "platformResolutionType"
    ) {
      fileName = payload.consentResolutionType.consentResolutionDocumentName;
      modeType = "not-signed-documents";
      subModeType = "platform-resolution-type";
    }

    /** Handles appointment of alternate director */
    if (payload.fileUploads?.appointmentLetter) {
      fileName = payload.fileUploads.appointmentLetter;
      modeType = "pre-signed-documents";
      subModeType = "self-resolution-type";
    } else if (
      payload.appointmentResolutionType?.appointmentResolutionType ===
      "ownResolutionType"
    ) {
      fileName = payload.fileUploads.appointmentResolutionType;
      modeType = "not-signed-documents";
      subModeType = "self-resolution-type";
    } else if (
      payload.appointmentResolutionType?.appointmentResolutionType ===
      "platformResolutionType"
    ) {
      fileName =
        payload.appointmentResolutionType.consentResolutionDocumentName;
      modeType = "not-signed-documents";
      subModeType = "platform-resolution-type";
    }

    let fileType = "";
    if (
      payload.fileUploads?.appointmentLetter ||
      payload?.appointmentResolutionType
    ) {
      fileType = Constants.Template_FILE_TYPES.APPOINTMENT_LETTER;
    } else {
      fileType = Constants.Template_FILE_TYPES.CONSENT_TO_ACT;
    }

    return {
      company: companyId,
      official: officialId,
      fileType,
      fileName: fileName,
      modeType: modeType,
      subModeType: subModeType,
    };
  };

  const createUploadChangeDocumentTemplate = async (uploadFilePayload) => {
    const fileUploadResponse = await dispatch(
      uploadTemplateFileAsync({ data: uploadFilePayload })
    );
    const uploadChangeDocumentTemplate = fileUploadResponse.payload.document;
    return uploadChangeDocumentTemplate;
  };

  const createUploadChangeDocumentPdf = async (uploadChangeDocument) => {
    let uploadChangePdfDocument = "";
    if (uploadChangeDocument.modeType === "not-signed-documents") {
      const convertToPdfResponse = await dispatch(
        convertTemplateToPdfAsync({
          data: uploadChangeDocument,
        })
      );
      uploadChangePdfDocument = convertToPdfResponse.payload.fileName;
    }
    return uploadChangePdfDocument;
  };

  const createUploadChangeDocsForOfficial = async (
    companyId,
    payload,
    official
  ) => {
    const uploadFilePayload = createUploadFilePayload(
      companyId,
      payload,
      official?._id
    );

    let updatedOfficial = {};

    if (uploadFilePayload.fileName && uploadFilePayload.modeType) {
      if (official) {
        const uploadChangeDocument = await createUploadChangeDocumentTemplate(
          uploadFilePayload
        );

        const uploadChangeDocumentPdf = await createUploadChangeDocumentPdf(
          uploadChangeDocument
        );

        let appointmentUpdate = {};

        if (
          uploadFilePayload.fileType ===
          Constants.Template_FILE_TYPES.CONSENT_TO_ACT
        ) {
          appointmentUpdate = {
            ...official?.uploadChangeDocuments?.appointment,
            consentToAct: {
              convertedPdf: uploadChangeDocumentPdf,
              templateFile: uploadChangeDocument?._id,
            },
          };
        } else {
          appointmentUpdate = {
            ...official?.uploadChangeDocuments?.appointment,
            appointmentLetter: {
              convertedPdf: uploadChangeDocumentPdf,
              templateFile: uploadChangeDocument?._id,
            },
          };
        }

        const officialUpdateData = {
          uploadChangeDocuments: {
            ...official?.uploadChangeDocuments,
            appointment: {
              ...appointmentUpdate,
            },
          },
          companyId,
          idType,
        };
        const response = await dispatch(
          updateCompanyOfficialAsync({
            officialId: official?._id,
            data: officialUpdateData,
          })
        );
        updatedOfficial = response.payload?.official;
      }
    }
    return updatedOfficial;
  };

  const addOrEditOfficial = async (
    values,
    resetForm,
    isAddMoreOfficial = false
  ) => {
    const uploadedFiles = await handleFilesUpload(
      values.fileUploads,
      currentOfficial,
      mode.editing
    );

    const payload = {
      ..._omit(values, [
        "fileUploads",
        "beneficialOwnershipForm",
        "companyAddressDetails",
        "companyNameDetails",
        "comments",
        "userId",
      ]),
      idType,
      designation,
      isDirector,
      fileUploads: {
        ..._pickBy(values.fileUploads, (file) => typeof file === "string"),
        ...uploadedFiles,
      },
    };
    const companyId = company?._id ?? params?.companyId;
    const isGuardian =
      values?.identificationDetails?.guardianEmailAddress ===
      currentUser.electronicAddress?.emailAddress;
    if (values.type === "invited" && isGuardian) {
      payload.inviteStatus = "Data Pending Review";
    }
    if (values.hasAccess) {
      payload.type = "invited";
      if (isProfessional(values.designation)) {
        payload.inviteStatus = values?.existingProfessional
          ? "Approved"
          : "Awaiting Data";
      } else payload.inviteStatus = "Approved";
    }

    if (
      isInChangesModule ||
      isInTransactionEditContext ||
      isInUpdateCompanyDetailsContext
    ) {
      payload["manageModuleStatus"] = "Draft";
      payload["isComingFromManageModule"] = true;
      payload[trxStorageKey] = window.localStorage.getItem(trxStorageKey);
      payload["changeType"] = Constants.TRANSACTION_CHANGE_TYPES.APPOINTMENT;
    }

    if (
      !mode.editing &&
      transactionToEdit?.changeType !==
        Constants.TRANSACTION_CHANGE_TYPES.APPOINTMENT
    ) {
      const response = await dispatch(
        addCompanyOfficialAsync({ companyId, data: clearEmpties(payload) })
      );
      if (
        (isInChangesModule ||
          isInTransactionEditContext ||
          isInUpdateCompanyDetailsContext) &&
        response?.payload?.official
      ) {
        setSelectedOfficial(response.payload.official);
        let updatedOfficial = {};
        if (payload?.fileUploads?.consentFormForAuthorizedPerson) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              fileUploads: {
                consentFormForAuthorizedPerson:
                  payload?.fileUploads?.consentFormForAuthorizedPerson,
              },
            },
            response.payload.official
          );
        }

        if (payload?.consentResolutionType) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              consentResolutionType: payload?.consentResolutionType,
              fileUploads: {
                consentResolutionType:
                  payload.fileUploads?.consentResolutionType,
              },
            },
            updatedOfficial?._id ? updatedOfficial : response.payload.official
          );
        }

        /** Handle Appointment Letter */
        if (payload?.fileUploads?.appointmentLetter) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              fileUploads: {
                appointmentLetter: payload?.fileUploads?.appointmentLetter,
              },
            },
            updatedOfficial?._id ? updatedOfficial : response.payload.official
          );
        }

        if (payload?.appointmentResolutionType) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              appointmentResolutionType: payload.appointmentResolutionType,
              fileUploads: {
                appointmentResolutionType:
                  payload.fileUploads?.appointmentResolutionType,
              },
            },
            updatedOfficial?._id ? updatedOfficial : response.payload.official
          );
        }

        let approvalType = "";
        if (props?.approvalType) {
          approvalType = props?.approvalType;
        } else {
          approvalType = Constants.TRANSACTION_APPROVAL_TYPES.BOARD_APPROVAL;
        }

        /** payload used during creation of a transaction */
        const initiatedChangePayload = {
          companyId: params.companyId,
          createdBy: currentUser._id,
          trxRef: window.localStorage.getItem(trxStorageKey),
          idType: response.payload.official.idType, // Pass the idType to determine if is corporate or individual during transaction creation
          officialId: response.payload.official._id,
          changeType: Constants.TRANSACTION_CHANGE_TYPES.APPOINTMENT,
          applicationType: designation,
          approvalType,
          batchNo: "",
          transactionType: Constants.TRANSACTION_TYPES.MANUAL,
        };
        values["actionRequestType"] = "one";
        let transactionResponse = "";

        if (batchNo) {
          initiatedChangePayload.batchNo = batchNo;
        }

        transactionResponse = await handleCompanyMaintenanceFormData(
          "new-request",
          initiatedChangePayload,
          params.companyId
        );

        /** Set trxRef for same transaction */
        window.localStorage.setItem(
          trxStorageKey,
          transactionResponse.payload.savedTransaction.trxRef
        );

        const trxId = transactionResponse.payload.savedTransaction._id;
        if (isInChangesModule || isInTransactionEditContext) {
          await dispatch(
            getAllInitiateTransactionChangeAsync({
              companyId,
              params: {
                limit: 10,
                skip: (1 - 1) * 10,
                search: "",
                sort: "updatedAt",
                order: "desc",
              },
            })
          );
        }
        if (isInUpdateCompanyDetailsContext) {
          setCreatedTransactionsIds([...createdTransactionsIds, trxId]);
        }

        if (!isAddMoreOfficial && !isInUpdateCompanyDetailsContext) {
          history.push(
            `/companies/${companyId}/dashboard/transactions/${trxId}/recent-changes`
          );
        } else {
          resetForm();
          setSelectedTabIndex(0);
        }
      }

      if (values?.type === "invited" && !values.hasAccess) {
        window.sessionStorage.setItem(
          "flashMessageCOTable",
          `we have successfully sent the invite to ${getMaskedEmail(
            values.initiatedToEmail
          )}.
        In case they do not receive any email, let them check the spam folder before initiating another invite.`
        );
      }
      return response;
    } else {
      const isOwnRow = [
        values?.electronicAddress?.emailAddress,
        values?.identificationDetails?.emailAddress,
      ].includes(currentUser.electronicAddress?.emailAddress);
      const isApplicant = currentUser?._id === company?.createdBy?._id;

      if (isOwnRow && payload.type === "invited" && !isApplicant) {
        payload.inviteStatus = "Data Pending Review";
      }
      let updatedOfficialData = {};

      formFields.map((formField) => {
        if (!_isEqual(props.currentOfficial[formField], payload[formField])) {
          updatedOfficialData[formField] = payload[formField];
        }
      });

      if (!_isEmpty(updatedOfficialData)) {
        let updatedOfficial = {};

        if (updatedOfficialData?.fileUploads?.consentFormForAuthorizedPerson) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              fileUploads: {
                consentFormForAuthorizedPerson:
                  updatedOfficialData?.fileUploads
                    ?.consentFormForAuthorizedPerson,
              },
            },
            mode.id
          );
        }

        if (updatedOfficialData?.consentResolutionType) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              consentResolutionType: updatedOfficialData?.consentResolutionType,
            },
            updatedOfficial?._id ? updatedOfficial : mode.id
          );
        }

        /** Handle Appointment Letter */
        if (updatedOfficialData?.fileUploads?.appointmentLetter) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              fileUploads: {
                appointmentLetter:
                  updatedOfficialData?.fileUploads?.appointmentLetter,
              },
            },
            updatedOfficial?._id ? updatedOfficial : mode.id
          );
        }

        if (updatedOfficialData?.appointmentResolutionType) {
          updatedOfficial = await createUploadChangeDocsForOfficial(
            companyId,
            {
              appointmentResolutionType:
                updatedOfficialData.appointmentResolutionType,
            },
            updatedOfficial?._id ? updatedOfficial : mode.id
          );
        }

        let originalDesignation = "";
        if (props?.changingShareholderDesignation) {
          if (values?.designation === Constants.APPLICANT_CAPACITIES.DIRECTOR) {
            originalDesignation = Constants.APPLICANT_CAPACITIES.SHAREHOLDER;
            const tempDesignation = values.designation;
            updatedOfficialData = {
              ...updatedOfficialData,
              designation: originalDesignation,
              tempDesignation,
            };
          }
        }

        const updatedOfficialResponse = await dispatch(
          updateCompanyOfficialAsync({
            officialId: mode.id,
            data: {
              ...updatedOfficialData,
              companyId,
              idType,
              appointmentDate: payload.appointmentDate
                ? payload.appointmentDate
                : "",
            },
          })
        );
        updatedOfficial = updatedOfficialResponse.payload?.official;

        if (props?.changingShareholderDesignation) {
          let approvalType = "";
          if (props?.approvalType) {
            approvalType = props?.approvalType;
          } else {
            approvalType = Constants.TRANSACTION_APPROVAL_TYPES.BOARD_APPROVAL;
          }
          /** payload used during creation of a transaction */
          const initiatedChangePayload = {
            companyId: params.companyId,
            createdBy: currentUser._id,
            trxRef: window.localStorage.getItem(trxStorageKey),
            idType: updatedOfficial?.idType, // Pass the idType to determine if is corporate or individual during transaction creation
            officialId: updatedOfficial?._id,
            changeType: Constants.TRANSACTION_CHANGE_TYPES.APPOINTMENT,
            applicationType: designation,
            approvalType,
            batchNo: "",
            transactionType: isInUpdateCompanyDetailsContext
              ? Constants.TRANSACTION_TYPES.MANUAL
              : Constants.TRANSACTION_TYPES.AUTOMATIC,
          };
          values["actionRequestType"] = "one";
          let transactionResponse = "";

          if (batchNo) {
            initiatedChangePayload.batchNo = batchNo;
          }

          transactionResponse = await handleCompanyMaintenanceFormData(
            "new-request",
            initiatedChangePayload,
            params.companyId
          );

          /** Set trxRef for same transaction */
          window.localStorage.setItem(
            trxStorageKey,
            transactionResponse.payload.savedTransaction.trxRef
          );

          const trxId = transactionResponse.payload.savedTransaction._id;
          if (isInChangesModule || isInTransactionEditContext) {
            await dispatch(
              getAllInitiateTransactionChangeAsync({
                companyId,
                params: {
                  limit: 10,
                  skip: (1 - 1) * 10,
                  search: "",
                  sort: "updatedAt",
                  order: "desc",
                },
              })
            );
          }

          if (isInUpdateCompanyDetailsContext) {
            setCreatedTransactionsIds([...createdTransactionsIds, trxId]);
          }
        }

        if (isOwnRow && payload.type === "invited" && !isApplicant) {
          window.sessionStorage.setItem(
            "flashMessageCOTable",
            `The application has been submitted back to the applicant for review.`
          );
          window.dispatchEvent(new Event("storage"));
        }
      }
    }

    if (isInTransactionEditContext) {
      dispatch(
        getAllInitiateTransactionChangeAsync({
          companyId,
          params: {
            limit: 10,
            skip: (1 - 1) * 10,
            search: "",
            sort: "updatedAt",
            order: "desc",
          },
        })
      );
      if (isAddMoreOfficial) {
        resetForm();
        setSelectedTabIndex(0);
      } else {
        history.push(
          `/companies/${companyId}/dashboard/transactions/${params.trxId}/recent-changes`
        );
      }
    }
  };

  const handleAddMoreCompanyOfficial = async (values, resetForm) => {
    const isAddMoreOfficial = true;
    setIsAddingOfficial(true);
    await addOrEditOfficial(values, resetForm, isAddMoreOfficial);
    setIsAddingOfficial(false);
  };

  const handleSubmit = async (values, resetForm) => {
    try {
      validateYupSchema(values, validationSchema, true);
      formStepErrors.current = {
        ...formStepErrors.current,
        [selectedTab.id]: [],
      };
    } catch (error) {
      formStepErrors.current = {
        ...formStepErrors.current,
        [selectedTab.id]: error.errors,
      };
      if (!isLastStep) {
        setTimeout(goToNextStep, Constants.DELAY_FORM_SUBMISSION);
        return;
      }
    }
    if (!isLastStep) {
      goToNextStep();
      return;
    }
    const officialSchema = getValidationSchema({
      idType,
      isNonResident: values.isNonResident,
      documentData,
      officialType: designation,
      showAppointmentDate,
    });
    try {
      setIsFormValid(true);
      validateYupSchema(values, officialSchema, true);
    } catch (error) {
      if (error.errors.length > 0) {
        setIsFormValid(false);
        return;
      }
    }
    if (!isViewOnly || company.createdBy._id === currentUser._id) {
      try {
        await addOrEditOfficial(values, resetForm);
        window.localStorage.removeItem(trxStorageKey);
      } catch (error) {}
    }
    dispatch(closeModal("companyOfficial_edit_modal"));
    toggleShowOfficialsForm(false);
    dispatch(resetSharesTable());
    resetForm();
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...initialValues,
        fileUploads: {
          ...initialValues.fileUploads,
          consentFormForAuthorizedPerson: "",
          appointmentLetter: "",
        },
        comments:
          transformedComments?.[currentOfficial?._id]?.["stakeholderTab"] ?? [],
      }}
      validate={(values) => {
        try {
          validateYupSchema(values, validationSchema, true, {
            makeFieldsOptional: isIdAssociated === false || isViewOnly,
          });
        } catch (err) {
          return yupToFormErrors(err);
        }
        return {};
      }}
      onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        resetForm,
        setTouched,
        submitCount,
      }) => {
        const isContactPerson =
          [
            values?.electronicAddress?.emailAddress,
            values?.identificationDetails?.emailAddress,
          ].includes(currentUser.electronicAddress?.emailAddress) &&
          values?.type === "invited";

        useEffect(() => {
          if (isContactPerson) {
            setFieldValue(
              "identificationDetails.companyContactName",
              getFullName(currentUser?.names)
            );
            setFieldValue(
              "identificationDetails.telNumber",
              currentUser?.electronicAddress?.mobileNumber ?? ""
            );
          }
        }, [isContactPerson]);

        useEffect(() => {
          if (
            selectedTab.id === "uploadChangeDocuments" &&
            isInUpdateCompanyDetailsContext
          ) {
            setValidationSchema(
              generateChangedDocumentsValidation(designation).schema
            );
          } else {
            setValidationSchema(
              getValidationSchema({
                selectedTab,
                idType,
                isNonResident: values.isNonResident,
                documentData,
                showAppointmentDate,
                designation,
              }).schema
            );
          }
        }, [
          selectedTab,
          idType,
          values.isNonResident,
          documentData,
          isInChangesModule,
          isInUpdateCompanyDetailsContext,
        ]);

        useEffect(() => {
          resetForm();
          formStepErrors.current = null;
        }, [idType]);

        // Reset touched fields on tab change, e.g fix errors jumping around
        useEffect(() => {
          setTouched({}, false);
          setIsFormValid(true);
        }, [selectedTab, setTouched]);

        // Update ErrorBanner errors when user update data
        useEffect(() => {
          if (formStepErrors.current?.[selectedTab.id]?.length > 0) {
            try {
              validateYupSchema(values, validationSchema, true);
              formStepErrors.current = {
                ...formStepErrors.current,
                [selectedTab.id]: [],
              };
            } catch (error) {
              formStepErrors.current = {
                ...formStepErrors.current,
                [selectedTab.id]: error.errors,
              };
            }
          }
        }, [values]);

        // Invite new user form
        if (inviteNewUserWorkflow && selectedTab.id !== "assignOfficials") {
          return (
            <InviteNewUser
              closeVerifyProcess={closeVerifyProcess}
              idType={idType}
              designation={designation}
              values={values}
              inviteOfficial={addOrEditOfficial}
            />
          );
        }

        if (inviteExistingUser) {
          return (
            <InviteExistingUser
              userId={values.userId}
              idType={idType}
              designation={designation}
              closeVerifyProcess={closeVerifyProcess}
              userEmailAddress={values.userEmailAddress}
              values={values}
              inviteOfficial={addOrEditOfficial}
            />
          );
        }

        const handleNewUserWorkflow = () => {
          if (Object.keys(errors).length > 0) {
            setTouched(setNestedObjectValues(errors, true));
            return;
          } else setInviteNewUserWorkflow(true);
        };

        const handleResetForm = () => {
          resetForm();
          formStepErrors.current = null;
        };

        return (
          <Form>
            {isIdAssociated === false &&
              formStepErrors.current?.[selectedTab.id]?.length > 0 && (
                <ErrorBanner
                  errors={[...(formStepErrors.current?.[selectedTab.id] ?? [])]}
                  className="my-4"
                />
              )}
            {/* Invite new user button */}
            {verificationValue &&
              isIdAssociated === false &&
              selectedTab.id &&
              !["assignOfficials", "generalInformation"].includes(
                selectedTab.id
              ) &&
              !mode.editing && (
                <button
                  type="button"
                  onClick={handleNewUserWorkflow}
                  className="inline-flex self-end justify-center px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm w-content bg-sflPrimary hover:bg-optional hover:text-sflPrimary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-optional disabled:hover:text-white"
                >
                  Invite
                </button>
              )}

            {/* Personal Information */}
            {selectedTab.id === "generalInformation" && (
              <div className="bg-white rounded-sm shadow-sm sm:rounded md:rounded-md">
                <div className="px-4 py-6 space-y-6 sm:p-6">
                  <div className="mb-4">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Personal Information
                    </h3>
                    <SectionDescription description="To activate the form fields please verify your ID first" />
                  </div>
                  {!mode.editing && (
                    <Verify
                      idType={idType}
                      designation={designation}
                      setShowIdentificationSection={
                        setShowIdentificationSection
                      }
                      verificationValue={verificationValue}
                      isIdAssociated={isIdAssociated}
                      isAccessAllowed={isAccessAllowed}
                      isAccessRevoked={isAccessRevoked}
                      setFieldValue={setFieldValue}
                      setVerifyingValue={setVerifyingValue}
                      setIsIdAssociated={setIsIdAssociated}
                      setDisableForm={setDisableForm}
                      resetForm={handleResetForm}
                      handleNewUserWorkflow={handleNewUserWorkflow}
                      setIsAccessAllowed={setIsAccessAllowed}
                      setIsAccessRevoked={setIsAccessRevoked}
                      setInviteExistingUser={setInviteExistingUser}
                      setTabsClickable={setTabsClickable}
                    />
                  )}
                  {showIdentificationSection && (
                    <>
                      {[
                        "Kenyan Citizen",
                        "Foreign Resident",
                        "Foreigner",
                        "Minor",
                        "Local Company",
                        "Foreign Company",
                        "Other e.g Parastatals",
                      ].includes(idType) && (
                        <>
                          {submitCount > 0 &&
                            disableForm &&
                            !isAccessAllowed &&
                            !isViewOnly &&
                            !changingShareholderDesignation && (
                              <div
                                className="py-1 text-sm bg-gray-200 items-center text-red-500 leading-none lg:rounded-full flex lg:inline-flex"
                                role="alert"
                              >
                                <span className="font-semibold px-2 text-left flex-auto">
                                  To activate the form fields please verify your
                                  ID
                                </span>
                              </div>
                            )}
                          <Field
                            name="names"
                            component={NamesForm}
                            idType={idType}
                            disabled={disableForm}
                            disableVerificationField={
                              isIdAssociated === false || mode.editing
                            }
                          />
                        </>
                      )}
                      <hr />
                      <IdentificationDetailsForm
                        idType={idType}
                        designation={designation}
                        disabled={disableForm}
                        disableVerificationField={
                          isIdAssociated === false || mode.editing
                        }
                        disableEmailAddress={
                          mode.editing && values?.type === "invited"
                        }
                        disableContactName={
                          mode.editing && values?.type === "invited"
                        }
                        disableTelNumber={
                          mode.editing && values?.type === "invited"
                        }
                      />
                      <hr />
                      <div className="grid grid-cols-6 gap-6">
                        {(isInChangesModule ||
                          isInUpdateCompanyDetailsContext) && (
                          <Field
                            name={"appointmentDate"}
                            component={ManageAppointmentDate}
                            idType={idType}
                            designation={designation}
                            registrationDate={company.registrationDate || ""}
                            disabled={!changingShareholderDesignation}
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            {/*  Address Particulars */}
            {selectedTab.id === "residentialDetails" && (
              <ResidentialDetails
                designation={designation}
                idType={idType}
                disabled={disableForm && !values?.enableLongForm}
                errors={errors}
                touched={touched}
                isNonResident={values.isNonResident}
              />
            )}
            {/* File Uploads Form */}
            {selectedTab.id === "uploadDocuments" && (
              <div className="mt-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md">
                <div className="px-4 py-6 sm:p-6">
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    KYC Document Uploads
                  </h3>
                  {[
                    "Kenyan Citizen",
                    "Foreign Resident",
                    "Foreigner",
                    "Minor",
                    "Local Company",
                    "Foreign Company",
                    "Other e.g Parastatals",
                  ].includes(idType) && (
                    <div className="mb-2">
                      <p>Please upload the correct documents as instructed</p>
                    </div>
                  )}
                  <Field
                    name="fileUploads"
                    component={FileUploadForm}
                    documentData={documentData}
                    disabled={
                      values?.resolvedFields &&
                      values?.resolvedFields.length > 0
                        ? !documentNames
                            .map((name) =>
                              values.resolvedFields?.includes(name)
                            )
                            .includes(false)
                        : disableForm &&
                          !values?.enableLongForm &&
                          !values.isIncompleteProfile
                    }
                  />
                </div>
              </div>
            )}
            {/* Change documents used in changes module */}
            {selectedTab.id === "uploadChangeDocuments" && (
              <div>
                <div className="mt-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md py-4 px-2">
                  {designation === "Alternate Director" && (
                    <Field
                      name="appointmentDocumentsAreSigned"
                      component={ChangedDocuments}
                      idType={idType}
                      designation={designation}
                      uploadRequestType="appointment-letter"
                      documentsFor="appointment-letter"
                      openKey={openKey}
                      setOpenKey={
                        isInUpdateCompanyDetailsContext ? null : setOpenKey
                      }
                      isInUpdateCompanyDetailsContext={
                        isInUpdateCompanyDetailsContext
                      }
                    />
                  )}
                  <Field
                    name="documentsAreSigned"
                    component={ChangedDocuments}
                    idType={idType}
                    designation={designation}
                    uploadRequestType="appointing-official"
                    documentsFor="uploadChangedDocuments"
                    openKey={openKey}
                    setOpenKey={
                      isInUpdateCompanyDetailsContext ? null : setOpenKey
                    }
                    isInUpdateCompanyDetailsContext={
                      isInUpdateCompanyDetailsContext
                    }
                  />
                </div>
                <div className="mt-4">
                  <span
                    onClick={() =>
                      handleAddMoreCompanyOfficial(values, resetForm)
                    }
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-sflPrimary border border-transparent rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:cursor-not-allowed"
                  >
                    {isAddingOfficial ? (
                      <span className="flex justify-evenly">
                        <SpinnerIcon />
                        Adding Official ...
                      </span>
                    ) : (
                      <>+ Add more {designation}</>
                    )}
                  </span>
                </div>
              </div>
            )}
            {isLastStep && !isFormValid && isIdAssociated === false && (
              <p className="text-sm text-red-500 my-2">
                Either enter all the required information or invite the
                official.
              </p>
            )}
            {selectedTab.id !== "assignOfficials" &&
              selectedTab.id !== "appointer" && (
                <div
                  className={`flex ${
                    isFirstStep ? "justify-end" : "justify-between"
                  } py-3 mt-2`}
                >
                  {!isFirstStep && (
                    <button
                      type="button"
                      disabled={isSubmitting}
                      onClick={goToPrevStep}
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gray-600 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:cursor-not-allowed"
                    >
                      Go back
                    </button>
                  )}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-sflPrimary border border-transparent rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:cursor-not-allowed"
                  >
                    {isSubmitting && isLastStep ? (
                      <>
                        <SpinnerIcon />
                        Submitting...
                      </>
                    ) : (
                      "Save and proceed"
                    )}
                  </button>
                </div>
              )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default CompanyOfficialsAuthorizedDirectorForm;

function generateChangedDocumentsValidation(designation) {
  let schema = {};

  if (designation === "Alternate Director") {
    schema = Yup.object().shape({
      fileUploads: Yup.object().shape({
        consentFormForAuthorizedPerson: Yup.string().required(
          "Consent form is required"
        ),
        appointmentLetter: Yup.string().required(
          "Appointment letter is required"
        ),
      }),
    });
  } else {
    schema = Yup.object().shape({
      fileUploads: Yup.object().shape({
        consentFormForAuthorizedPerson: Yup.string().required(
          "Consent form is required"
        ),
      }),
    });
  }
  return {
    schema,
  };
}
